export function PricingTable({
  rows,
  setCurrentZone,
  setModalTitle,
  setModalShow,
}) {
  return (
    <div className="pricing-table" style={{ overflowX: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr className="gradient-primary">
            <th className="pricing-header" style={{ textAlign: "left" }}>
              ZONA
            </th>
            <th className="pricing-header" style={{ textAlign: "center" }}>
              PRECIO
            </th>
          </tr>
        </thead>

        <tbody>
          {rows.event_zone?.map((zone, idx) => {
            const isSoldOut = parseInt(zone.sold_out, 10) === 1
            const color = zone.color_event_zone || "#6c757d"

            const handleClick = () => {
              if (isSoldOut) return
              // enable when the presale date is passed
              if (!rows.presale_enabled) {
                setCurrentZone(zone)
                setModalTitle("Comprar entradas: " + zone.name_event_zone)
                setModalShow(true)
              }
            }

            return (
              <tr
                key={zone.id_event_zone ?? idx}
                className={"pricing-row " + (isSoldOut ? "opacity-75" : "pricing-row-clickable")}
                onClick={handleClick}
                style={{
                  cursor: isSoldOut ? "not-allowed" : "pointer",
                }}
                role="button"
                tabIndex={isSoldOut ? -1 : 0}
                onKeyDown={(e) => {
                  if (isSoldOut) return
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault()
                    handleClick()
                  }
                }}
                aria-disabled={isSoldOut ? "true" : "false"}
              >
                {/* SECTOR (con esencia del diseño anterior: icono + color + agotado) */}
                <td className="pricing-cell">
                  <div className="d-flex align-items-center">
                    <div
                      className="d-flex align-items-center justify-content-center rounded-3 me-3"
                      style={{
                        width: 40,
                        height: 40,
                        backgroundColor: color + "22",
                        color: 'white',
                        border: `1px solid white`,
                      }}
                    >
                      <i className="fas fa-ticket-alt" />
                    </div>

                    <div style={{ minWidth: 0 }}>
                      <div
                        className="sector-name fw-bold text-uppercase text-white"
                        style={{
                          fontSize: "0.9rem",
                          letterSpacing: "0.03em",
                          color: isSoldOut ? "#6c757d" : color,
                          textDecoration: isSoldOut ? "line-through" : "none",
                        }}
                      >
                        {zone.name_event_zone}
                        {isSoldOut && (
                          <span className="ms-2 text-white" style={{ fontWeight: 700 }}>
                            · Agotado
                          </span>
                        )}
                      </div>

                      <div className="sector-type small text-white">
                        {zone.name_type_event_zone}
                      </div>
                    </div>
                  </div>
                </td>

                {/* PRECIO (misma data del anterior) */}
                <td className="pricing-cell" style={{ textAlign: "center" }}>
                  <div className="price fw-bold">
                    {zone.price_ticket_event_zone} {zone.name_money}
                  </div>
                  <div className="price-note text-white small">+ cargos</div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
